{
  "general": {
    "orgs": {
      "title": "Create New Enterprise",
      "save": "Save",
      "cancel": "Cancel",
      "editName": "Edit name",
      "yesTitle": "Yes, {{title}}",
      "enterpriseListSuperAdmin": {
        "header": "Super Admins",
        "add": "Add Super Admin",
        "remove": "Remove"
      },
      "enterpriseListChildOrgs": {
        "header": "Active Child Orgs",
        "add": "Add Child Org",
        "detach": "Detach"
      },
      "enterpriseListDeactivatedAccounts": {
        "remove": "Remove",
        "header": "Deactivated Child Orgs",
        "detachPrerequisite": "Detach or deactivate all child organizations first",
        "deactivateAccount": "Deactivate \"{{name}}\"",
        "reactivate": "Reactivate \"{{name}}\"",
        "detachDeactivated": "Detach deactivated",
        "deactivateWarning": "This is the last step in deactivating enterprise process. Make sure all the child organizations billing & contract setting are updated by a CSM.",
        "deactivate": "Deactivate",
        "detach": "Detach"
      },
      "orgNamePlacholder": "Name",
      "addSuperAdminLabel": "Add Super Admins",
      "addSuperAdminPlaceholder": "Type or paste superadmins emails (comma-separated) and hit enter",
      "addSuperAdminTagPlaceholder": "Hit enter to add superadmins",
      "addChildOrgLabel": "Add Child Organizations",
      "addChildOrgPlaceholder": "Type or paste child organization accountids (comma-separated) and hit enter",
      "addChildOrgTagPlaceholder": "Hit enter to add accounts",
      "addAuthDomainPlaceholder": "Type or paste auth domains (comma-separated) and hit enter",
      "addAuthDomainTagPlaceholder": "Hit enter to add auth domains",
      "orgNameLabel": "Enterprise Org Name",
      "nameError": "Name cannot be blank",
      "childOrgsError": "No child orgs set",
      "superadminsError": "No admins set",
      "authDomainsError": "No auth domains set",
      "currentlyDeactivated": "This enterprise is currently deactivated",
      "moveChild": "Move child accounts between enterprises by detaching from current enterprise and attaching to the new enterprise"
    },
    "superadmins": {
      "title": "Super Admins",
      "empty": "No super admins added",
      "deleteConfirmation": "Delete <strong>{{ email }}</strong> from {{ orgName }}?",
      "addModalTitle": "Add Super Admin",
      "addPlaceholder": "Enter email",
      "addLabel": "Super Admin",
      "you": "you",
      "errors": {
        "alreadyExists": "Super admin {{ email }} already exists",
        "invalidEmail": "Invalid email"
      }
    },
    "name": {
      "title": "Enterprise Organization Name"
    },
    "deactivateChildAccounts": {
      "title": "Deactivate Child-Organization",
      "description": "Deactivating an account will purge all logging history. There is no 'undo' for this.",
      "selectChildLabel": "Select Child-Organization",
      "selectChildPlaceholder": "Select Child-Organization",
      "deactivateButton": "Deactivate Child Account",
      "deactivated": "deactivated",
      "modal": {
        "title": "Deactivate a Child-Organization",
        "description": "The child-organization named <strong>{{ name }}</strong> and all logs associated with it will be deleted. Once this organization is deleted, it can not be recovered. Enter the child-organization’s account ID (<span class='text-info'>{{ account }}</span>) to confirm.",
        "placeholder": "Child-Organization ID",
        "deactivateButton": "Deactivate"
      }
    }
  },
  "accessManagement": {
    "signInPolicy": "Sign-in Policy",
    "enterpriseServiceAccounts": "Enterprise Service Accounts",
    "legacyEnterpriseServiceKeys": "Legacy Enterprise Service Keys",
    "serviceKeysDescription": "The following service keys can be used for managing Log Analysis configuration via <a target='_blank' href='https://docs.$t(common:defaultHost)/log-analysis-api/ref#tag-configuration'>API</a> or <a href='https://docs.$t(common:defaultHost)/docs/terraform-provider' target='_blank'>Terraform</a>.",
    "generateKey": "Generate Service Key",
    "keyTitle": "Service Key",
    "deprecatedMessage": "Legacy Enterprise service keys are deprecated, please use Enterprise Service keys instead. You can still use your existing Legacy Enterprise service keys, but they will be removed in the future."
  },
  "discoverability": {
    "title": "Child organization discoverability",
    "description": "Enable child organization admins to allow users with an <strong>{{ domains }}</strong> email to discover and join the organizations. If not enabled, child organizations will not be discoverable.",
    "warning": "No domains have been defined. Please contact your Customer Success Manager."
  },
  "childOrg": {
    "title": "Child Organizations",
    "desc": "All the child organizations that in your enterprise account will be listed here.  Including active feature, retention period and numbers of admins.",
    "createNew": "Create New",
    "addById": "Add by ID",
    "search": "Search by Child Organization Name or Acccount ID",
    "noResultsTitle": "No Results Found",
    "noResultsMessage": "The filters returned no results.",
    "detachModal": {
      "title": "Detach Child Organization",
      "description": "Are you sure you want to detach this child organization?",
      "confirm": "Detach",
      "cancel": "Cancel",
      "success": "Successfully detached child organization.",
      "error": "Unable to detach child organization.  Please try again."
    },
    "addModal": {
      "buttonText": "Add Child Organization",
      "title": "Add Child Organization",
      "description": "To add a new child organization you will need to provide the account owner or admin your enterprise account id <code>{{enterpriseId}}</code>.  The admin will then need to navigate <strong>Settings > Organization > Access Management</strong> and paste the you Enterprise account ID into the Enterprise Consent Signature field and send you the generated token.",
      "consentSignature": "Enter consent signature token",
      "childAccountId": "Child Account ID",
      "steps": {
        "title": "Steps to add a new child organization:",
        "step1": "Send the child account admin your Enterprise account ID: <code>{{enterpriseId}}</code>",
        "step2": "Have the account admin navigate to <strong>Settings > Organization > Access Management</strong>",
        "step3": "Paste the provided Enterprise account ID into the Enterprise Consent Signature form to generate the token",
        "step4": "Have the account admin send the generated token back",
        "step5": "Paste the token into the consent signature token field below",
        "step6": "Click the ok button"
      }
    },
    "addByIdModal": {
      "title": "Add By Child Organization ID",
      "findServiceKey": "Find the service key under the organization/API keys",
      "serviceKeyPlaceholder": "Enter Service Key",
      "serviceKey": "Service Key",
      "serviceKeyDisclaimer": "As a best practice, we recommend you create a new service key to complete the add.",
      "selectRetentionTier": "Select Retention Tier",
      "accountIdPlaceholder": "Enter Child Organization ID",
      "childOrgName": "Child Organization Name",
      "hideExample": "Hide Example",
      "showExample": "Show Example",
      "exampleDesc": "Find the child organization ID on top of your HTML address of the child-organization.",
      "childOrgId": "Child Organization ID"
    },
    "createModal": {
      "title": "Create child organization",
      "childNameLabel": "Child organization name",
      "childNamePlaceholder": "Enter a name for the organization",
      "retentionLabel": "Retention tier",
      "retentionPlaceholder": "Select a retention tier",
      "retentionSelectLabel": "Set as retention period",
      "retentionSelectDays": "days",
      "hipaaLabel": "HIPAA compliant?",
      "ownerLabel": "Primary admin",
      "ownerPlaceholder": "Add primary admin email",
      "ownerSelectLabel": "Set as primary admin",
      "ownerTagPlaceholder": "Add as primary admin",
      "adminsLabel": "Additional admins",
      "adminsPlaceholder": "Add/Enter emails",
      "adminsSelectLabel": "Add as admin"
    },
    "fields": {
      "name": "Child organization name",
      "activeFeatures": "Active features",
      "retentionPeriod": "Max retention period",
      "edit": "Edit",
      "admin": "Admin"
    },
    "features": {
      "usageQuotas": "Usage Quotas",
      "indexRateAlerts": "Index Rate Alerts",
      "exclusionRules": "Exclusions Rules",
      "variableRetention": "Variable Retention",
      "thresholdAlerts": "Threshold Alerts"
    },
    "accountID": "Account ID",
    "retentionPeriodCellValuePluralHipaa": "{{days}} Days (HIPAA)",
    "retentionPeriodCellValueHipaa": "{{days}} Day (HIPAA)",
    "retentionPeriodCellValuePlural": "{{days}} Days",
    "retentionPeriodCellValue": "{{days}} Day"
  },
  "dashboard": {
    "graph": {
      "title": "Usage trends",
      "graphTitle": "Usage graph",
      "descriptionSize": "All organizational usage information is calculated in volume (GB, MB, etc).",
      "descriptionLines": "All organizational usage information is calculated in number of log lines.",
      "descriptionSizeDetailed": "Trends and percentage breakdowns of child organizations, sources, apps, and tags are calculated in volume (GB, MB, etc).",
      "descriptionLinesDetailed": "Trends and percentage breakdowns of child organizations, sources, apps, and tags are calculated using the number of log lines."
    },
    "usageTable": {
      "title": "Usage table",
      "description": "This table reflects the graph above.",
      "table": {
        "fields": {
          "name": {
            "accounts": "Child organization name",
            "apps": "App name",
            "hosts": "Host name",
            "tags": "Tag name"
          },
          "currentTotal": "Used",
          "totalUsage": "% Total usage"
        },
        "notConfigured": "Not configured"
      },
      "total": "<strong>Total:</strong> <span class='text-muted'>{{ totalSources }} {{ type }}</span>"
    },
    "methodologyError": "Cannot display usage because child accounts are using different billing methodologies. Please contact your customer success manager."
  },
  "serverErrors": {
    "updateName": "Unable to update enterprise name. Please try refreshing the page.",
    "deactivateAccount": "Unable to deactivate child account. Please try refreshing the page.",
    "updateSuperadmins": "Unable to update super admins. Please try refreshing the page.",
    "updateSAML": "Unable to update SAML configuration. Please try refreshing the page.",
    "failedToAddEnterpriseUsers": "Unable to add the following users to the enterprise: {{users}}"
  },
  "usage": {
    "averageIndex": "Average index rate",
    "averageIngest": "Average ingest rate",
    "totalOrgs": "Total child orgs",
    "totalsTip": "We calculate these metrics using data from the current billing period.",
    "linesPerSecond": "{{value}} lines/s",
    "exportAsJson": "Export data as .json"
  }
}
